import { getOrCreateI18n } from '@affine/i18n';
import type { ReactiveController, ReactiveControllerHost } from 'lit';

export class PreviewLocaleController implements ReactiveController {
  private readonly i18n = getOrCreateI18n();

  constructor(private readonly host: ReactiveControllerHost) {
    host.addController(this);
  }

  private readonly _onLanguageChanged = () => {
    this.host.requestUpdate();
  };

  hostConnected() {
    this.i18n.on('languageChanged', this._onLanguageChanged);
  }

  hostDisconnected() {
    this.i18n.off('languageChanged', this._onLanguageChanged);
  }

  t(key: string, fallback: string) {
    const value = this.i18n.t(key, { defaultValue: fallback });
    return typeof value === 'string' ? value : fallback;
  }
}
